import { render } from "./ModalContainer.vue?vue&type=template&id=7c870f9c&scoped=true"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"

import "./ModalContainer.vue?vue&type=style&index=0&id=7c870f9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c870f9c"]])

export default __exports__